import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { HelperService } from 'app/shared/services/helper-service/helper.service';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MonitoringWeatherData } from '../monitoring-weather/monitoring-weather.component';

@Component({
    selector: 'app-performance-monitoring',
    templateUrl: './performance-monitoring.component.html',
    styleUrls: ['./performance-monitoring.component.scss'],
    standalone: false
})
export class PerformanceMonitoringComponent implements OnInit, OnChanges {

  @Input() unit: string;
  @Input() hours: number[];
  @Input() data: any;
  @Input() popupContent = null;
  @Output() hoursSelected = new EventEmitter<number>();

  public yAxesPowerMax: number;
  public yAxesWindspeedMax: number;
  public buttons: string[];
  public active;
	public weatherData: MonitoringWeatherData;
  public activeAlarm = 0;
  private unsubscriber = new ReplaySubject();

  constructor(
    private helper: HelperService,
    private translate: TranslateService
  ) { }

  public ngOnInit() {
    this.subscribeTranslateService();
  }

  public ngOnChanges(): void {
    this.generateButtons();
    if (this.data) {
      this.active = this.buttons.indexOf('COMMON.MINUS_' + this.data.hours + 'H');
      this.calculatePowerStepsAxis(this.data.ratedPower);
      if (this.data?.history?.windSpeed) {
        this.calculateWindspeedStepsAxis(this.data.history.windSpeed);
      }
      this.weatherData = this.data?.history?.weather?.map(this.mapWeatherData);
    }
  }

  public handleActiveAlarmsChanged(index: number) {
    this.activeAlarm = index;
  }

  private generateButtons(): void {
    this.buttons = this.hours.map(hour => 'COMMON.MINUS_' + hour + 'H');
  }

  private calculatePowerStepsAxis(ratedPower: number): void {
    const calcStepsAxisObject = this.helper.calcStepsAxis(ratedPower);
    this.yAxesPowerMax = calcStepsAxisObject.yAxisMax || 1;
  }

  private calculateWindspeedStepsAxis(windSpeed: number[]): void {
    const maxWindspeed = windSpeed.reduce((a, b) => Math.max(a, b), -Infinity);
    const calcStepsAxisObject = this.helper.calcStepsAxis(maxWindspeed * 1.1);
    this.yAxesWindspeedMax = calcStepsAxisObject.yAxisMax || 1;
  }

  public handleActiveChanged(index: number): void {
    this.hoursSelected.emit(this.hours[index]);
  }

  private subscribeTranslateService() {
    this.translate.onLangChange.pipe(takeUntil(this.unsubscriber)).subscribe((event: LangChangeEvent) => {
      this.generateButtons();
    });
  }

  private mapWeatherData(weatherData): MonitoringWeatherData {
    return {
      temperature: weatherData.WNAC1_ExTmp_avg_mag_f,
      wind_speed: weatherData.WNAC1_WdSpd_avg_mag_f,
      wind_direction: weatherData.WNAC1_WdDir_avg_mag_f,
      icon: weatherData.icon,
      timestamp: weatherData.timestamp
    };
  }
}
